import { FormInput, NAMESPACE } from '@ui-kit'
import { FieldValues } from 'react-hook-form'
import { NPIRenderPropTypes } from '../../types/common'
import { validateNpi } from '@app-store'
import { useState } from 'react'
import { useParams } from 'react-router-dom'

const NPIRender = <T extends FieldValues>({
  name,
  label,
  disabled = false,
  placeholder = '',
  register,
  errors,
  validation,
  clearErrors: _clearErrors,
  ...rest
}: NPIRenderPropTypes<T>) => {
  const [validating, setValidating] = useState<boolean>(false)
  const { caseId, id } = useParams()
  return (
    <div className="flex items-center">
      <FormInput
        name={name}
        label={label}
        disabled={disabled}
        errors={errors}
        placeholder={placeholder}
        register={register}
        validation={{
          ...validation,
          validate: {
            thirdParty: async (fieldValue) => {
              try {
                setValidating(true)
                if (!fieldValue) return
                const res = await validateNpi(
                  fieldValue,
                  id || '',
                  caseId || ''
                )
                return (
                  (res && res?.data?.Scenario === 'Valid') ||
                  NAMESPACE.INVALID_NPI
                )
              } catch {
                return NAMESPACE.INVALID_NPI
              } finally {
                setValidating(false)
              }
            },
          },
        }}
        {...rest}
      />
      {validating && (
        <div className="ml-2">
          <output
            className="animate-spin inline-block size-5 border-[3px] border-current border-t-transparent text-secondary-500 rounded-full dark:text-secondary-500"
            aria-label="loading"
          ></output>
        </div>
      )}
    </div>
  )
}

export default NPIRender
